var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechtcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 543.93 157.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2563eb;}.cls-2{fill:#111827;}.cls-3{fill:none;}.cls-4{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.32,55.2a26.21,26.21,0,0,1,11,10.49A31.54,31.54,0,0,1,177.2,81.5a51.66,51.66,0,0,1-.61,7.19H132.3a11.39,11.39,0,0,0,5,7.51,18.31,18.31,0,0,0,10.62,2.87,29.21,29.21,0,0,0,8.78-1.34A22.41,22.41,0,0,0,164,93.94l10,10.74A35.43,35.43,0,0,1,161.89,112a43.21,43.21,0,0,1-14.95,2.57,40.21,40.21,0,0,1-18.18-3.85A27.72,27.72,0,0,1,116.92,99.8a32.53,32.53,0,0,1-4.15-16.72,32.82,32.82,0,0,1,4.09-16.47,28.52,28.52,0,0,1,11.41-11.17,35.11,35.11,0,0,1,17-4A36.79,36.79,0,0,1,162.32,55.2ZM136.51,69.54a11.42,11.42,0,0,0-4.09,8.17H159a11.16,11.16,0,0,0-3.84-8.17q-3.48-2.92-9.34-2.93A14.33,14.33,0,0,0,136.51,69.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.08,110.6a27.6,27.6,0,0,1-11.59-10.92,32.56,32.56,0,0,1-4.09-16.6,32.36,32.36,0,0,1,4.15-16.53,28.84,28.84,0,0,1,11.59-11.11,36.12,36.12,0,0,1,17.21-4,34.89,34.89,0,0,1,12.81,2.38,32.18,32.18,0,0,1,10.86,7l-10.61,11.6a17.16,17.16,0,0,0-12.08-4.76,14.39,14.39,0,0,0-10.74,4.21,15,15,0,0,0-4.15,11q0,6.84,4.09,11a14.34,14.34,0,0,0,10.8,4.21A17.32,17.32,0,0,0,231,93l10.86,11.47a33.21,33.21,0,0,1-24.17,10A38.24,38.24,0,0,1,200.08,110.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.24,58.92q6.54,7.44,6.53,20.14v34H293.61V80.15q0-5.85-2.86-9.15a10.06,10.06,0,0,0-8-3.29,11.78,11.78,0,0,0-9.09,3.78,14,14,0,0,0-3.47,9.88V113.1H251V27.68h19.16V59.41q6.94-7.94,18.42-7.93Q299.71,51.48,306.24,58.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.45,27.68V45.13H356.34v68h-20v-68h-26V27.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.87,109.44A39.47,39.47,0,0,1,392.76,93.7a46.9,46.9,0,0,1-5.67-23.31A46.44,46.44,0,0,1,392.88,47a40,40,0,0,1,16.17-15.75,49.42,49.42,0,0,1,23.67-5.55A44.68,44.68,0,0,1,465.18,39L452.86,51.36a28.88,28.88,0,0,0-33.25-4.46,23.07,23.07,0,0,0-9.16,9.46,29.6,29.6,0,0,0-3.23,14,29.61,29.61,0,0,0,3.23,14,23,23,0,0,0,9.16,9.45,27.05,27.05,0,0,0,13.6,3.36A31.76,31.76,0,0,0,444.93,95a28.08,28.08,0,0,0,9.76-6.35l11.71,13.06a46.21,46.21,0,0,1-33.31,13.3Q419.3,115.05,408.87,109.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M477.87,27.68h20V95h43V113.1h-63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.1,55.34h-5.71c0,.95.08,1.9.08,2.85s0,1.91-.08,2.85h5.71c0-.95.07-1.89.07-2.85S107.14,56.29,107.1,55.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.69,32.27h16.9a0,0,0,0,1,0,0v87.07a8.45,8.45,0,0,1-8.45,8.45h0a8.45,8.45,0,0,1-8.45-8.45V32.27A0,0,0,0,1,65.69,32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.22,32.27h16.9a0,0,0,0,1,0,0v87.07a8.45,8.45,0,0,1-8.45,8.45h0a8.45,8.45,0,0,1-8.45-8.45V32.27A0,0,0,0,1,89.22,32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.97,
    y: -9.43,
    width: 17.11,
    height: 82.58,
    transform: "translate(162.38 -98.67) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.73,
    y: -10.17,
    width: 17.11,
    height: 82.58,
    transform: "translate(72.4 -10.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.62-54.09h0a0,0,0,0,1,0,0V72.22a0,0,0,0,1,0,0h0A18.12,18.12,0,0,1,56.5,54.09V-36A18.12,18.12,0,0,1,74.62-54.09Z",
    transform: "translate(74.62 -56.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.84,
    cy: 11.65,
    r: 9.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.84,
    cy: 11.65,
    r: 5.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.11,
    cy: 51.51,
    r: 9.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 17.11,
    cy: 51.51,
    r: 5.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.8,
    cy: 51.51,
    r: 5.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 74.16,
    cy: 118.55,
    r: 5.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 97.65,
    cy: 118.55,
    r: 5.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.44,140.57H91.6v-2.78H103v2.78H99.12v16.7H95.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.74,137.79h10v2.78h-6.35v5.15h5v2.78h-5v6h6.35v2.78h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118,156.29a4.51,4.51,0,0,1-1.38-3.53V142.3a4.51,4.51,0,0,1,1.38-3.53,7.07,7.07,0,0,1,8.06,0,4.49,4.49,0,0,1,1.39,3.53v2.06H124V142.1a1.84,1.84,0,0,0-3.68,0V153a1.6,1.6,0,0,0,1.84,1.78c1.23,0,1.84-.59,1.84-1.78v-3h3.48v2.75a4.49,4.49,0,0,1-1.39,3.53,7.07,7.07,0,0,1-8.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.69,137.79h3.68v7.93h3.94v-7.93H141v19.48h-3.68V148.5h-3.94v8.77h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152,140.57h-3.85v-2.78h11.37v2.78h-3.84v16.7H152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.56,137.79h5l3.82,19.48h-3.68L167,153.4v.06h-4.18l-.67,3.81h-3.41Zm4,13-1.63-9.62h-.07l-1.61,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.13,137.79h3.68v16.7h6.05v2.78h-9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.63,137.79h10v2.78h-6.36v5.15h5.05v2.78h-5.05v6h6.36v2.78h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.77,137.79h4.62L205,149.45H205V137.79h3.28v19.48h-3.78l-4.41-14.22h-.07v14.22h-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.93,140.57h-3.85v-2.78h11.37v2.78h-3.84v16.7h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.58,137.79h9.73v2.78h-6.06V146H237v2.78h-4.75v8.49h-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.25,156.27a4.6,4.6,0,0,1-1.44-3.62V142.41a4.6,4.6,0,0,1,1.44-3.62,7.35,7.35,0,0,1,8.29,0,4.6,4.6,0,0,1,1.44,3.62v10.24a4.6,4.6,0,0,1-1.44,3.62,7.35,7.35,0,0,1-8.29,0Zm6.05-3.43V142.22a1.91,1.91,0,1,0-3.81,0v10.62a1.91,1.91,0,1,0,3.81,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.46,137.79h5.45a6.39,6.39,0,0,1,4.14,1.1,4.17,4.17,0,0,1,1.31,3.38v1.2q0,3-2.41,3.84v.05a2.8,2.8,0,0,1,1.89,1.37,5.79,5.79,0,0,1,.55,2.75v3.42a9.8,9.8,0,0,0,.07,1.35,2.77,2.77,0,0,0,.33,1h-3.74a3.43,3.43,0,0,1-.27-.89,10.17,10.17,0,0,1-.07-1.5v-3.57a2.6,2.6,0,0,0-.52-1.86,2.44,2.44,0,0,0-1.78-.53h-1.28v8.35h-3.67Zm5,8.35a2.53,2.53,0,0,0,1.66-.47,2,2,0,0,0,.55-1.59v-1.5a2.15,2.15,0,0,0-.45-1.53,1.87,1.87,0,0,0-1.42-.48h-1.68v5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.44,156.29a4.49,4.49,0,0,1-1.39-3.53V142.3a4.49,4.49,0,0,1,1.39-3.53,7.07,7.07,0,0,1,8.06,0,4.51,4.51,0,0,1,1.38,3.53v2.06h-3.47V142.1a1.84,1.84,0,0,0-3.68,0V153c0,1.19.61,1.78,1.84,1.78a1.6,1.6,0,0,0,1.84-1.78v-3h3.47v2.75a4.51,4.51,0,0,1-1.38,3.53,7.07,7.07,0,0,1-8.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.09,137.79h5.45a6.4,6.4,0,0,1,4.15,1.1,4.17,4.17,0,0,1,1.3,3.38v1.2q0,3-2.4,3.84v.05a2.76,2.76,0,0,1,1.88,1.37,5.78,5.78,0,0,1,.56,2.75v3.42a12.07,12.07,0,0,0,.06,1.35,3,3,0,0,0,.34,1h-3.75a3.82,3.82,0,0,1-.26-.89,10.17,10.17,0,0,1-.07-1.5v-3.57a2.6,2.6,0,0,0-.52-1.86,2.47,2.47,0,0,0-1.79-.53h-1.27v8.35h-3.68Zm5,8.35a2.52,2.52,0,0,0,1.65-.47,2,2,0,0,0,.56-1.59v-1.5a2.15,2.15,0,0,0-.46-1.53,1.86,1.86,0,0,0-1.42-.48h-1.67v5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.57,137.79h10v2.78h-6.35v5.15h5.05v2.78h-5.05v6h6.35v2.78h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.55,137.79h5l3.82,19.48h-3.68L318,153.4v.06h-4.18l-.67,3.81h-3.41Zm4,13-1.63-9.62h-.07l-1.61,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.46,140.57h-3.85v-2.78H333v2.78h-3.84v16.7h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.75,137.79h3.68v19.48h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.2,137.79h3.72l2.4,15.11h.07l2.41-15.11h3.38l-3.55,19.48h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354,137.79h10v2.78h-6.35v5.15h5.05v2.78h-5.05v6H364v2.78H354Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.44,137.79h3.68v16.7h6.05v2.78h-9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M382.94,137.79h10v2.78h-6.35v5.15h5.05v2.78h-5.05v6H393v2.78h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M397.92,137.79h5l3.81,19.48H403l-.67-3.87v.06h-4.18l-.67,3.81h-3.41Zm4,13-1.64-9.62h-.07l-1.6,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.49,137.79h5.62a6,6,0,0,1,4.11,1.23,4.53,4.53,0,0,1,1.37,3.59v9.85a4.52,4.52,0,0,1-1.37,3.58,6,6,0,0,1-4.11,1.23h-5.62Zm5.55,16.7a2,2,0,0,0,1.39-.45,1.91,1.91,0,0,0,.49-1.45V142.47a1.91,1.91,0,0,0-.49-1.45,2,2,0,0,0-1.39-.45h-1.87v13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422.07,137.79h10v2.78h-6.35v5.15h5.05v2.78h-5.05v6h6.35v2.78h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434.21,137.79h5.45a6.42,6.42,0,0,1,4.15,1.1,4.17,4.17,0,0,1,1.3,3.38v1.2q0,3-2.41,3.84v.05a2.8,2.8,0,0,1,1.89,1.37,5.79,5.79,0,0,1,.55,2.75v3.42a11.7,11.7,0,0,0,.07,1.35,3,3,0,0,0,.33,1H441.8a4.44,4.44,0,0,1-.27-.89,11.85,11.85,0,0,1-.07-1.5v-3.57a2.65,2.65,0,0,0-.51-1.86,2.49,2.49,0,0,0-1.79-.53h-1.27v8.35h-3.68Zm5,8.35a2.53,2.53,0,0,0,1.66-.47,2,2,0,0,0,.55-1.59v-1.5a2.15,2.15,0,0,0-.45-1.53,1.87,1.87,0,0,0-1.42-.48h-1.67v5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M448.42,156.28a4.7,4.7,0,0,1-1.37-3.63v-1.11h3.48v1.33a1.67,1.67,0,0,0,1.9,1.89,2,2,0,0,0,1.42-.45,2,2,0,0,0,.49-1.49,3.58,3.58,0,0,0-.67-2.16,11.15,11.15,0,0,0-2.47-2.24,13.16,13.16,0,0,1-3.18-3,5.35,5.35,0,0,1-.9-3,4.55,4.55,0,0,1,1.4-3.58,5.93,5.93,0,0,1,4.08-1.27,5.7,5.7,0,0,1,4,1.27,4.72,4.72,0,0,1,1.35,3.63v.81h-3.48v-1a2,2,0,0,0-.46-1.46,1.89,1.89,0,0,0-1.38-.46,1.64,1.64,0,0,0-1.84,1.86,3.24,3.24,0,0,0,.69,2,12.16,12.16,0,0,0,2.49,2.22,12.45,12.45,0,0,1,3.18,3,5.83,5.83,0,0,1,.87,3.2,4.73,4.73,0,0,1-1.42,3.68,6,6,0,0,1-4.13,1.28A5.74,5.74,0,0,1,448.42,156.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M460.13,137.79h3.68v7.93h3.94v-7.93h3.68v19.48h-3.68V148.5h-3.94v8.77h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M474.17,137.79h3.68v19.48h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.59,137.79H486a6,6,0,0,1,4.11,1.23,4.53,4.53,0,0,1,1.37,3.59v1.92a4.52,4.52,0,0,1-1.37,3.58,6,6,0,0,1-4.11,1.23h-1.74v7.93h-3.68Zm5.42,8.77a1.92,1.92,0,0,0,1.35-.42,1.84,1.84,0,0,0,.46-1.42v-2.31a1.84,1.84,0,0,0-.46-1.42,1.92,1.92,0,0,0-1.35-.42h-1.74v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M494.37,156.28a4.66,4.66,0,0,1-1.37-3.63v-1.11h3.48v1.33a1.67,1.67,0,0,0,1.9,1.89,2,2,0,0,0,1.42-.45,2,2,0,0,0,.49-1.49,3.58,3.58,0,0,0-.67-2.16,11.25,11.25,0,0,0-2.48-2.24,13.27,13.27,0,0,1-3.17-3,5.36,5.36,0,0,1-.91-3,4.56,4.56,0,0,1,1.41-3.58,5.93,5.93,0,0,1,4.08-1.27,5.7,5.7,0,0,1,4,1.27,4.72,4.72,0,0,1,1.35,3.63v.81h-3.48v-1a1.93,1.93,0,0,0-.47-1.46,1.85,1.85,0,0,0-1.37-.46,1.64,1.64,0,0,0-1.84,1.86,3.24,3.24,0,0,0,.69,2,12.16,12.16,0,0,0,2.49,2.22,12.45,12.45,0,0,1,3.18,3,5.83,5.83,0,0,1,.87,3.2,4.73,4.73,0,0,1-1.42,3.68,6,6,0,0,1-4.13,1.28A5.74,5.74,0,0,1,494.37,156.28Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 493.19,
    y1: 149.53,
    x2: 533.6,
    y2: 149.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.1,149.33c1.62-.21,3.24-.34,4.86-.51h29.11c1.62.16,3.24.29,4.86.5-1.62.2-3.24.33-4.86.5H510C508.34,149.66,506.72,149.54,505.1,149.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.33,149.33c1.61-.21,3.23-.34,4.85-.51H88.3c1.61.16,3.23.29,4.85.5-1.62.2-3.24.33-4.85.5H59.18C57.56,149.66,55.94,149.54,54.33,149.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechtcl);
export default __webpack_public_path__ + "static/media/techtcl.10cd4f3e9cc78ae7bd8a3402f257455f.svg";
export { ForwardRef as ReactComponent };